module.exports = __webpack_public_path__ + "bfc0407764ed5b5242d56923c464613d.svg";